import React, { useEffect, useState } from "react";
import styles from "./Resultado.module.css";
import axios from "axios";
import ReactGA from "react-ga";
import {  useNavigate } from "react-router-dom";

import TextoGanador from "../../components/textoGanador/textoGanador";
import TextoPerdedor from "../../components/textoPerdedor/textoPerdedor";
import {  useSelector } from "react-redux";

import LogoPrincipal from "./assets/LogoPrincipalHome.png";
import LogoConcierto from "./assets/CoollogoConciertos.png";
import Gaseosas from "./assets/Gaseosas.png";
import LogoIsm from "./assets/LogoISM.png";
import GaseosasMobile from "./assets/GaseosasMobile.png";
import LogoISMMobile from "./assets/LogoISMMobile.png";

import { Link } from "react-router-dom";

const Resultado2 = () => {
  const [PuntosUser, setPuntosUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const dni = useSelector((state) => state.dni);
  const Code = useSelector((state) => state.code);
  const navigate = useNavigate();

  // const InfoName = async () => {
  //   try {
  //     const resp = await axios.put("https://backgaseosaspromo-production.up.railway.app/users" , {
  //       DNI : dni,
  //       codigo :  Code
  //     })

  //     setPuntosUser(resp.data)
  //     setIsLoading(false)
  //    console.log(resp.data)

  //   } catch (error) {
  //      console.log(error)
  //   }

  // }

  useEffect(() => {
    ReactGA.pageview("/registro");

    document.title =
      "Resultado: Destapa y gana conciertos gratis por un año / Cool Fresh, una marca de ISM";

    // Actualizar la descripción de la página
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Ingresa otro código para destapar y ganar conciertos gratis por un año con Cool Fresh, una marca de ISM"
      );
    }

    const fetchData = async () => {
      try {
        const resp = await axios.put(
           "https://winged-rain-production.up.railway.app/users",
      
          {
            DNI: dni,
            // codigo: Code,
            codigo: Code.toUpperCase(),
          }
        );

        setPuntosUser(resp.data);
        setIsLoading(false);
        console.log(resp.data);
      } catch (error) {
        console.log(error);
      }
    };
 
    fetchData(); // Llamamos a la función fetchData directamente dentro del useEffect
  }, []);

  
  const redirect = async () => {
    try {
        navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  

  return (
    <div className={styles.Home}> 
      {/* <Link to={"/prueba"}> */}
        <img
        onClick={redirect}
          alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
          src={LogoPrincipal}
          className={styles.LogoPrincipal} 
          style={{zIndex:'200'}}
        ></img>
      {/* </Link> */}
      <div className={styles.lefDiv}>
      {isLoading ? (
     //   <div className={styles.divTexto}>
     //     <h2 className={styles.cargando} >Cargando...</h2>
     //   </div>
          <div className={styles.divTexto}>
              <TextoGanador puntos={10} />
            </div>
      ) : (
        <div>
          {PuntosUser.PuntoParaElUsuario ? (
            <div className={styles.divTexto}>
              <TextoGanador puntos={PuntosUser.puntos} />
            </div>
          ) : (
            <div className={styles.divTexto}>
              <TextoPerdedor />
            </div>
          )}
        </div>
      )}
    

      <Link to={"/Bienvenido"}>
        <button className={styles.button}>INGRESA OTRO CÓDIGO</button>
      </Link>
      </div>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoConcierto}
        className={styles.LogoConcierto}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={Gaseosas}
        className={styles.Gaseosas}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={GaseosasMobile}
        className={styles.GaseosasMobile}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoIsm}
        className={styles.LogoIsm}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoISMMobile}
        className={styles.LogoISMMobile}
      ></img>
    </div>
  );
};

export default Resultado2;
